export default "__VITE_ASSET__45e00277__"